import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "table-page-cnt"
};
const _hoisted_2 = {
  class: "tb-pg-toolbar"
};
const _hoisted_3 = {
  key: 0,
  class: "table-page-header"
};
const _hoisted_4 = {
  key: 1,
  class: "tb-pg-searchbar"
};
const _hoisted_5 = {
  class: "tb-pg-content x-list-content"
};
const _hoisted_6 = {
  key: 0,
  class: "x-list-error"
};
const _hoisted_7 = {
  key: 1,
  class: "x-list-loading"
};
const _hoisted_8 = {
  class: "x-list"
};
const _hoisted_9 = {
  key: 0,
  class: "list-no-data"
};
import { computed, toRefs } from 'vue';
import { XToolbar } from '@/components';
import { CloseCircleOutlined } from '@ant-design/icons-vue';
const __default__ = {
  name: 'XListLayout'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    toolbar: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      default: ''
    },
    rows: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    columnCount: {
      type: Number,
      default: 1
    }
  },
  emits: ['toolbar-item-click'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const {
      rows,
      total,
      loading,
      error
    } = toRefs(props);
    const emit = __emit;
    const toolbarItems = computed(() => props.toolbar);
    const handleToolbarItemClick = item => {
      emit('toolbar-item-click', item);
    };
    const itemColStyle = computed(() => {
      if (props.columnCount > 0) {
        return {
          width: `${100 / props.columnCount}%`
        };
      }
      return {
        width: '100%'
      };
    });
    return (_ctx, _cache) => {
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_empty = _resolveComponent("a-empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "toolbar", {}, () => [_createVNode(_unref(XToolbar), {
        items: toolbarItems.value,
        onItemClick: handleToolbarItemClick
      }, null, 8, ["items"])])]), _ctx.$slots.header ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "header")])) : _createCommentVNode("", true), _ctx.$slots.searchbar ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_renderSlot(_ctx.$slots, "searchbar")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_unref(error) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_unref(CloseCircleOutlined)), _createElementVNode("span", null, "出错了:" + _toDisplayString(_unref(error)), 1)])) : _unref(loading) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_a_spin, {
        size: "large"
      }), _cache[0] || (_cache[0] = _createElementVNode("span", null, "加载中...", -1))])) : _createCommentVNode("", true), !_unref(error) && !_unref(loading) ? _renderSlot(_ctx.$slots, "list", {
        key: 2,
        rows: _unref(rows),
        total: _unref(total)
      }, () => [_createElementVNode("div", _hoisted_8, [_unref(rows).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_a_empty)])) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(_unref(rows), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "x-item-col",
          style: _normalizeStyle(itemColStyle.value)
        }, [_renderSlot(_ctx.$slots, "renderItem", {
          row: item,
          index: index
        })], 4);
      }), 128))])]) : _createCommentVNode("", true)])]);
    };
  }
});